export default "__VITE_ASSET__CQ5Q2Dq4__"